<!--这是单独打开的svg界面,指定图的-->
<template>
  <div>
    <websvgplayer :svgpath="realPath" ref="websvgplayer" class="websvgplayer"></websvgplayer>
    <svgDialog ref="svgDialog"></svgDialog>
  </div>
</template>

<script>
  import websvgplayer from '@/components/module/svg/webSvgPlayer.vue'
  import svgDialog from '@/components/module/svg/svgDialog.vue'
  export default {
    components: {
      websvgplayer,
      svgDialog
    },
    props: [],
    data () {
      return {
        measureHeightTimer: undefined,
        nowPage: undefined
      }
    },
    created () {
      debugPage=this
    },
    mounted () {
      addNewTask("measureHeight",0,500,6,() => {
        var title=document.getElementsByClassName("topMenu")[0]
        if(this.$refs.websvgplayer==undefined) {
          return
        }
        measureHeight(document.getElementById("app").offsetHeight,[{
          object: title
        },{
          object: this.$refs.websvgplayer.$el,
          needChange: true,
        }])
      })
      this.nowPage=this.tempPage
    },
    destroyed () {
      clearInterval(this.measureHeightTimer)
    },
    computed: {
      tempPage () {
        return this.$store.menuStore.state.nowMenu.pageFile
      },
      realPath () {
        return "/static/svgFile/"+this.nowPage
      }
    },
    watch: {
      tempPage (nv,ov) {
        this.nowPage=nv
      }
    },
    methods: {
      showSvgDialog (path) {
        this.$refs.svgDialog.showSvgDialog(path)
      }
    }
  }
</script>

<style scoped>
  .websvgplayer {
    width: 100%;
    height: 100%;
  }
</style>